import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const getFloorTypes = () => ({ type: "GET_FLOOR_TYPES" })
export const getFloorTypesRequest = () => ({ type: "GET_FLOOR_TYPES_REQUEST" })
export const getFloorTypesSuccess = payload => ({ type: "GET_FLOOR_TYPES_SUCCESS", payload })
export const getFloorTypesFailed = error => ({ type: "GET_FLOOR_TYPES_FAILED", error })

export function* getFloorTypesSaga() {
    yield put(getFloorTypesRequest())
    try {
        let { data: payload } = yield call(axios,"/floor_types")
        yield put(getFloorTypesSuccess(payload))
    } catch(err){
        yield put(getFloorTypesFailed(err))
    }
}

export default function* floorTypesSagaWatcher() {
    yield takeEvery("GET_FLOOR_TYPES", getFloorTypesSaga)
}